import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-plinks',
  template: '<router-outlet></router-outlet>',
  styles: []
})
export class PlinksComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}

